export default __webpack_public_path__ + "static/media/photo-charte10.0b0e90c3.png";